<template>
    <div class="px-3" style="font-size: 13px;">
        <v-col cols="12" justify="center" align="center" class="py-0 px-0" v-if="summary_data != null || transit_data != null">
            <v-row class="px-0 mx-0 py-0 my-0">
                <v-col cols="11" class="pl-12">
                    <v-row justify="center" align="center">
                        <h3 class="pb-2">{{ current_month[0][$store.state.language] }}</h3>
                    </v-row>
                </v-col>
                <v-col cols="1" class="px-0 mx-0">
                    <v-row justify="end" class="px-0 mx-0">
                        <v-btn small text style="max-width: 15px; min-width: 15px;" class="pb-2" @click="leftMonth">
                            <v-icon>chevron_left</v-icon>
                        </v-btn>
                        <v-btn small text style="max-width: 15px; min-width: 15px;" class="pb-2" @click="rightMonth">
                            <v-icon>chevron_right</v-icon>
                        </v-btn>
                    </v-row>
                </v-col>
            </v-row>
            
            <div class="horizontal-separator-bold"></div>
            
            <v-row class="px-0 mx-0 py-0 my-0" justify="center" align="center">
                {{ $t('yego_dashboard.business_days_elapsed') }}
            </v-row>
            
            <v-row class="px-0 mx-0 pb-3 mt-0" justify="center" align="center">
                <v-col cols="3" class="py-0"></v-col>
                <v-col cols="1" class="py-0">1</v-col>
                <v-col cols="1" class="py-0">2</v-col>
                <v-col cols="1" class="py-0">3</v-col>
                <v-col cols="1" class="py-0">4</v-col>
                <v-col cols="1" class="py-0">5</v-col>
                <v-col cols="1" class="py-0">6</v-col>
                <v-col cols="1" class="py-0">7</v-col>
                <v-col cols="1" class="py-0">8</v-col>
                <v-col cols="1" class="py-0">9+</v-col>
            </v-row>

            <div class="horizontal-separator-bold mb-3"></div>

            <v-row class="px-0 mx-0" justify="center" align="center" v-for="row in summary_data.rows" :key="row.label">
                <v-col cols="3" class="pt-1 pb-0" style="text-align: start;"> {{ row.label }} ({{ row.total }})</v-col>
                <v-col cols="1" class="pt-1 pb-0"> {{ row.days[0].count }} </v-col>
                <v-col cols="1" class="pt-1 pb-0"> {{ row.days[1].count }} </v-col>
                <v-col cols="1" class="pt-1 pb-0"> {{ row.days[2].count }} </v-col>
                <v-col cols="1" class="pt-1 pb-0"> {{ row.days[3].count }} </v-col>
                <v-col cols="1" class="pt-1 pb-0"> {{ row.days[4].count }} </v-col>
                <v-col cols="1" class="pt-1 pb-0"> {{ row.days[5].count }} </v-col>
                <v-col cols="1" class="pt-1 pb-0"> {{ row.days[6].count }} </v-col>
                <v-col cols="1" class="pt-1 pb-0"> {{ row.days[7].count }} </v-col>
                <v-col cols="1" class="pt-1 pb-0"> {{ row.days[8].count }} </v-col>
            </v-row>
            
            <div class="horizontal-separator-bold mt-3"></div>

            <v-row class="px-0 mx-0 pb-3 mt-0" justify="center" align="center">
                <v-col cols="5" class="py-0" style="text-align: start;"></v-col>
                <v-col cols="1" class="py-0" style="font-weight: bold;">{{ $t('yego_dashboard.d_b_delivered') }}</v-col>
                <v-col cols="1" class="py-0" style="font-weight: bold;">{{ $t('yego_dashboard.d_b_returned') }}</v-col>
                <v-col cols="1" class="py-0" style="font-weight: bold;">{{ $t('yego_dashboard.d_b_exceptions') }}</v-col>
                <v-col cols="1" class="py-0" style="font-weight: bold;">{{ $t('yego_dashboard.d_b_in_transit') }}</v-col>
                <v-col cols="1" class="py-0" style="font-weight: bold;">{{ $t('yego_dashboard.d_b_high') }}</v-col>
                <v-col cols="1" class="py-0" style="font-weight: bold;">{{ $t('yego_dashboard.d_b_medium') }}</v-col>
                <v-col cols="1" class="py-0" style="font-weight: bold;">{{ $t('yego_dashboard.d_b_low') }}</v-col>
            </v-row>

            <v-row class="px-0 mx-0 py-0 my-0" justify="end" align="center" style="font-size: 10px !important; font-style: italic;">
                <v-col cols="" class="py-0"></v-col>
                <v-col cols="7" class="py-0"> {{ $t('yego_dashboard.delivery_probability_note') }}</v-col>                
            </v-row>

            <div class="horizontal-separator-bold mb-3"></div>

            <v-row class="px-0 mx-0" v-for="state in transit_data.states" :key="state.state">
                <v-col cols="5" class="py-0" style="text-align: start;">{{state.state}}</v-col>
                <v-col cols="1" class="py-0" style="font-weight: bold;">{{ state.delivered.count }}</v-col>
                <v-col cols="1" class="py-0" style="font-weight: bold;">{{ state.returned.count }}</v-col>
                <v-col cols="1" class="py-0" style="font-weight: bold;">{{ state.exceptions.count }}</v-col>
                <v-col cols="1" class="py-0" style="font-weight: bold;">{{ state.transit.high_probability.count + state.transit.medium_probability.count + state.transit.low_probability.count }}</v-col>
                <v-col cols="1" class="py-0" style="font-weight: bold;">{{ state.transit.high_probability.display }}</v-col>
                <v-col cols="1" class="py-0" style="font-weight: bold;">{{ state.transit.medium_probability.display }}</v-col>
                <v-col cols="1" class="py-0" style="font-weight: bold;">{{ state.transit.low_probability.display }}</v-col>

                <div class="horizontal-separator"></div> 
            </v-row>
        </v-col>
    </div>
</template>
<script>
export default {
    props: [
        'current_month',
        'summary_data',
        'transit_data'
    ],
    data() {
        return {}
    },
    methods: {
        leftMonth() {
            this.$emit("leftMonth");
        },
        rightMonth() {
            this.$emit("rightMonth");
        }
    }
}
</script>